import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight,
  faEnvelope,
  faMailbox,
} from '@fortawesome/pro-regular-svg-icons';

import { useTranslation } from '@utils/i18n/i18n';

import './more-information.css';

const cards = [
  {
    id: 'news',
    title: 'News and updates',
    description: 'Check out the ENHANCE project website for more information.',
    icon: faMailbox,
    colorName: 'green',
    onClick: () => window.open('https://enhance-onehealth.eu/', '_blank', 'noopener,noreferrer'),
  },
  {
    id: 'contact',
    title: 'Contact',
    description: 'Contact us with your questions.',
    icon: faEnvelope,
    colorName: 'orange',
    onClick: () => window.open('https://enhance-onehealth.eu/contact/', '_blank', 'noopener,noreferrer'),
  },
];

function MoreInformation() {
  const { t } = useTranslation();

  return (
    <section className="more-information">
      <h2>{t('More information')}</h2>
      <div className="more-information__cards">
        {cards.map(card => (
          <button
            className={`more-information__card more-information__card--${card.colorName}`}
            key={card.id}
            onClick={card.onClick}
            type="button"
          >
            <span className="more-information__card__content">
              <span className="more-information__card__icon" aria-hidden="true">
                <FontAwesomeIcon icon={card.icon} />
              </span>
              <span className="more-information__card__title">{t(card.title)}</span>
              <span className="more-information__card__description">{t(card.description)}</span>
            </span>
            <span className="more-information__card__arrow" aria-hidden="true">
              <FontAwesomeIcon icon={faArrowRight} />
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}

export default MoreInformation;
